"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleSwitch = void 0;
var _react = require("react");
var _ToggleSwitch = require("./ToggleSwitch.styles");
var _Icon = require("../Icon");
var _events = require("../../utilities/events");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _jsxRuntime = require("react/jsx-runtime");
var ToggleSwitch = function ToggleSwitch(props) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    themeColors = _useContext.themeColors;
  var id = props.id,
    isDisabled = props.isDisabled,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    _props$isChecked = props.isChecked,
    isChecked = _props$isChecked === void 0 ? false : _props$isChecked,
    onClick = props.onClick;
  var styles = (0, _ToggleSwitch.useStyles)(props);
  var handleClick = function handleClick() {
    if (!isDisabled && onClick) {
      onClick(id);
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    (0, _events.handleSpaceOrEnterDown)(event, handleClick);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: styles['cc-ToggleSwitch'],
    tabIndex: isDisabled ? -1 : 0,
    onKeyDown: handleKeyDown,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      type: "checkbox",
      checked: isChecked,
      disabled: isDisabled,
      onChange: handleClick,
      "aria-label": id,
      "data-testid": id
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: styles['cc-ToggleSwitch__slider'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: styles['cc-ToggleSwitch__slider-thumb'],
        children: isChecked && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: styles['cc-ToggleSwitch__slider-thumb-icon'],
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            name: "Checkmark",
            width: "75%",
            height: "75%",
            fillColor: color === 'primary' ? themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main : themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.dark
          })
        })
      })
    })]
  }, "cc-ToggleSwitch--".concat(id));
};
exports.ToggleSwitch = ToggleSwitch;